import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { authApi, LoginPayload, RegisterPayload } from '../../../services/authApi';
import { AuthResponse } from '../../../helpers/types';
import { setAuthToken } from '../../../helpers/request';
import { notificationsActions } from '../../Notifications/slice';
import { portalActions } from '../../../layouts/MainLayout/slice';
import { loginActions as actions } from '.';

function* handleLogin(action: PayloadAction<LoginPayload>) {
  try {
    const data = (yield call(authApi.login, action.payload)) as AuthResponse;
    setAuthToken(data.accessToken);
    yield put(portalActions.sessionEstablished(data.user));
    yield put(actions.authSuccess());
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Login failed';
    yield put(actions.authFailure(message));
    yield put(
      notificationsActions.setNotification({ message, type: 'error' }),
    );
  }
}

function* handleRegister(action: PayloadAction<RegisterPayload>) {
  try {
    const data = (yield call(
      authApi.register,
      action.payload,
    )) as AuthResponse;
    setAuthToken(data.accessToken);
    yield put(portalActions.sessionEstablished(data.user));
    yield put(actions.authSuccess());
    yield put(
      notificationsActions.setNotification({
        message: 'Account created successfully',
        type: 'success',
      }),
    );
  } catch (error) {
    const message =
      error instanceof Error ? error.message : 'Registration failed';
    yield put(actions.authFailure(message));
    yield put(
      notificationsActions.setNotification({ message, type: 'error' }),
    );
  }
}

export function* loginSaga() {
  yield takeLatest(actions.loginRequest.type, handleLogin);
  yield takeLatest(actions.registerRequest.type, handleRegister);
}
